import {useState, useEffect} from 'react';
import {getAdditives} from "../../services/Administrative/additiveService";

export const useGetAdditives = ({filters = {}}) => {
    const [additives, setAdditives] = useState<any[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);

    const addAdditiveLocally = (newAdditive: any) => {
        const transformedAdditive = {
            NOMBRE: newAdditive.name,
            CLAVE: newAdditive.uniqueCode,
            ID: newAdditive.id
        }

        setAdditives((prevAdditives: any) => [...prevAdditives, transformedAdditive]);
    };

    const updateAdditiveLocally = (uniqueCode: string, updatedName: string) => {
        setAdditives((prevAdditives) => {
            const updatedAdditives = prevAdditives.map((additive) =>
                additive.CLAVE === uniqueCode
                    ? {...additive, NOMBRE: updatedName}
                    : additive
            );
            return updatedAdditives;
        });
    };


    useEffect(() => {
        const fetchAdditives = async () => {
            setIsLoading(true);
            try {
                const response: any = await getAdditives(page, filters);
                setAdditives(response.additives);
                setTotalPages(response.totalPages);
                setPage(response.page);
            } catch (error: any) {
                console.log(error);
            } finally {
                setTimeout(() => {
                    setIsLoading(false)
                }, 600)
            }
        };
        fetchAdditives();
    }, [page, filters]);

    return {additives, totalPages, isLoading, page, setPage, addAdditiveLocally, updateAdditiveLocally};
};
